import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import FilterBar from './filterBar';
import QueriesTable from './queriesTable';

export default function Queries(props) {
    const {} = props;

    return (
        <>
            <FilterBar />
            {/*  */}
            <Grid container spacing={2}>
                {/* Queries Table */}
                <Grid item xs={12}>
                    <QueriesTable />
                </Grid>
              
            </Grid>
        </>
    );
}
